export const getUpdatedFileList = ({
  file: { uid, percent, status },
  fileList,
}) => {
  const changedFile = fileList?.find((file) => file.uid === uid);
  const fileRemoved = !changedFile;
  const filesToKeep = fileList?.filter((file) => file.uid !== uid);

  if (fileRemoved) return fileList;

  changedFile.percent = percent;
  changedFile.status = status || changedFile.status;

  return [...filesToKeep, changedFile];
};
